<template>
  <div>
    <b-card>
        <template slot="header">
            <h4 class="mt-2 custom-card-header-text">Feedback</h4>
            <ul class="list-inline float-right header_table">
                <li v-if="communities.length>1" class="list-inline-item place-center"><label for="communityFilter" class="custom-card-header-filter label-bottom-0">Community:</label></li>
                <li v-if="communities.length>1" class="list-inline-item">
                    <b-form-select v-model="selected" @change="filterByCommunity()" class="custom-card-header-filter" id="communityFilter">
                        <option :value="null" selected disabled>Community</option>
                        <option value="all">All</option>
                        <option v-for="community in communities" :key="community._id" v-bind:value="community._id">{{ community.name}}</option>
                    </b-form-select>
                </li>
                <li v-if="circles.length>=1" class="list-inline-item place-center"><label for="circleFilter" class="custom-card-header-filter label-bottom-0">Circle:</label></li>
                <li v-if="circles.length>=1" class="list-inline-item">
                    <b-form-select v-model="selectedCircle" @change="filterByCircle()" class="custom-card-header-filter" id="circleFilter">
                        <option :value="null" selected disabled>Circle</option>
                        <option value="all">All</option>
                        <option value="none">No Circle</option>
                        <option v-for="(circle, idx) in circles" :key="`${idx}$-{circle.short}`" v-bind:value="circle.short" v-if="circle.name && circles.length>=1" >{{ circle.name}}</option>
                    </b-form-select>
                </li>
                <li>
                    <div class="row-bak d-flex-bak align-items-center-bak">
                        <datepicker @changed="dateFilter" :value="datepickerPreset"
                        style="padding-right: 10px;" label="Date Range"></datepicker>
                    </div>
                </li>
                <li class="list-inline-item">
                    <button type="button" aria-label="Export" aria-live="assertive" v-if="exportBtn" @click="exportData()" title="Download feedback data"  class="btn custom-card-header-filter btn-dropbox tab-focus"><i class="icon-cloud-download"></i></button>
                    <button type="button" v-if="processBtn" v-b-tooltip.hover.bottom title="Generating report" class="btn custom-card-header-filter btn-dropbox"><i class="fa fa-spinner fa-spin"></i></button>
                </li>
            </ul>
        </template>
        <b-card-body>
            <!-- Use the search section component -->
            <search-section search-placeholder="Search Feedback..." @search="handleSearch" @limit-change="handleLimitChange"/>
            <!-- The real table (header included) stays mounted and visible the whole time —
                 only its rows get masked. Keeps its internal state intact and avoids a second,
                 different-looking header. -->
            <div class="table-refresh-wrapper" :class="{ 'is-refreshing': isTableLoading }">
            <v-server-table v-if="isReady" ref="feedbackTable" :url="serverURL" :columns="columns" :options="options" name="dataTable" id="dataTable" class="feedback-table">
                <span slot="name" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
                    {{props.row.name}}
                </span>
                <span slot="name" slot-scope="props" v-else-if="props.row.name">
                    {{props.row.name}}
                </span>
                <span slot="received" slot-scope="props" v-if="props.row.received">
                    {{ props.row.received | momentDate }}
                </span>
                <span slot="feedback" slot-scope="props" v-if="props.row.feedback">
                    {{props.row.feedback}}
                </span>
                <span slot="feedback" slot-scope="props" v-else>
                    {{'N/A'}}
                </span>
                <span slot="received" v-else>N/A</span>
                <span slot="action" slot-scope="props">
                    <b-button :aria-label="props.row.commentCount > 0 ? 'View ' + props.row.commentCount : 'View the request'"
                        v-b-tooltip.hover.bottom class="notification-btn" variant="dropbox tab-focus" size="sm" @click="openRequestInNewTab(props.row.requestId)">
                        <span class="count" v-if="props.row.commentCount">{{props.row.commentCount}}</span>
                        <i class="icon-eye"></i>
                    </b-button>
                </span>
            </v-server-table>
            </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';
import { shuffleArray } from '@/shared/utils'
import { exportCSV } from '@/assets/js/common';
import { sanitizeInput } from '../../utils/sanitizer';
var moment = require('moment-timezone');
import VueNotifications from 'vue-notifications';
import datepicker from './components/datePicker';
import SearchSection from '@/views/engagement/components/searchSection.vue';

export default {
    name: 'satisfactions',
    components: {
		datepicker,
        SearchSection
	},
    data() {
        return {
            satisfactions: [],
            communities: [],
            circles: [],
            isReady: false,
            isTableLoading: false,
            selected: "all",
            selectedCircle: "all",
            selectedDates: {
                startDate: new Date(0),
                endDate: new Date()
            },
            // Drives the date-range dropdown's displayed label — without this the
            // dropdown defaults to an unbound `null`, which renders as a disabled,
            // blank-looking "All" option instead of showing what's actually applied.
            datepickerPreset: 'last-30',
            getDateISO(date) {
                if (!date) return '';
                if (typeof date === 'string') return date.split('T')[0];
                if (date instanceof Date && !isNaN(date)) return date.toISOString().split('T')[0];
                return '';
            },
            searchQuery: '',
            askCount: 0,
            columns: ['community', 'circleName', 'received', 'name', 'type', 'rating', 'feedback','action'],
            token: '',
            options: {
                headings: {
                    requestId: 'Request ID',
                    circleName: 'Circle'
                },
                sortable: [ 'circleName', 'received', 'name', 'type', 'rating', 'feedback'],
                sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                pagination: {
					show: false,
					dropdown: false,
                    chunk: 10,
                    nav: 'fixed'
                },
                requestFunction: async function (data) {
                    if (data.query) {
                        // Reset if malicious content is detected
                        if (data.query.toLowerCase().includes('javascript:') ||
                            data.query.toLowerCase().includes('data:') ||
                            data.query.toLowerCase().includes('vbscript:')) {
                            data.query = '';
                            // Reset the filter input
                            const table = this.$parent.$refs.dataTable;
                            if (table && table.$refs.filter) {
                                table.$refs.filter.value = '';
                            }
                        }
                        data.query = sanitizeInput(data.query);
                    }
                    this.$parent.searchQuery = data.query;
                    this.$parent.isTableLoading = true;
                    return await axios.get(this.url, {headers: {'x-access-token': localStorage.getItem('token')},  params: data})
                        .catch(function (e) {
                            if (e.response.status  === 401) {
                                localStorage.removeItem('authUser');
                                this.$router.push('/login');
                            }
                        }.bind(this))
                        .finally(function () { this.$parent.isTableLoading = false; }.bind(this));
                },
                responseAdapter({data}) {
                    this.$parent.askCount = data.askCount;
                    return {
                        data : data.feedback,
                        count: data.askCount
                    }
                },
				filterable: true,
				perPageDropdown: [],
				// Blank out the library's own "Loading..." placeholder — it rendered as a
				// second, overlapping loading message alongside our own indicator above.
				texts: { loading: '' }
            },
            serverURL: `${process.env.VUE_APP_API_BASE_URL}/dashboard/satisfaction`,
            exportBtn: true,
            processBtn: false
        }
    },
    notifications: {
        showDownloadingMsg: {
            type: VueNotifications.types.success,
            message: "Export request sent.  Data is now downloading."
        },
        showWarnMsg: {
            type: VueNotifications.types.warn,
            message: "No data found for export file"
        }
    },
    async created() {
        this.token = localStorage.getItem('token');

        // This page never read startDate/endDate from the URL at all — landing here
        // from the Feedback widget (which does forward them) was silently ignored,
        // always falling back to all time. Default to the last 30 days when nothing
        // is passed, matching the widget's own default window.
        const startDateParam = this.$route.query.startDate;
        const endDateParam = this.$route.query.endDate;
        if (startDateParam && endDateParam) {
            this.selectedDates.startDate = new Date(startDateParam);
            this.selectedDates.endDate = new Date(endDateParam);
        } else {
            this.selectedDates.startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
            this.selectedDates.endDate = new Date();
        }
        // The dates above already drive the actual query, but datepickerPreset (the
        // dropdown's displayed label) was never updated to match — it stayed hardcoded
        // at 'last-30' regardless of what range was actually forwarded, e.g. showing
        // "Last 30 Days" while really filtering to Year to Date. Map the forwarded
        // timeframe (same param the Feedback widget now sends) to the dropdown's preset.
        const timeframe = this.$route.query.timeframe;
        if (timeframe) {
            const timeframeToPreset = { weekly: 'last-7', monthly: 'last-30', ytd: 'ytd', all: null, custom: 'custom' };
            this.datepickerPreset = timeframe in timeframeToPreset ? timeframeToPreset[timeframe] : this.datepickerPreset;
        }

        const communityIdParam = this.$route.params.community_id
            || this.$route.query.community_id
            || localStorage.getItem('user_modal_option');
        if (communityIdParam && communityIdParam !== 'all') {
            this.selected = communityIdParam;
            this.serverURL = `${process.env.VUE_APP_API_BASE_URL}/dashboard/${this.selected}/satisfactions?startDate=${this.getDateISO(this.selectedDates.startDate)}&&endDate=${this.getDateISO(this.selectedDates.endDate)}`;
        }

        await this.getCommunities();
    },
    methods: {
        dateFilter(res) {
            // Save selected dates
            this.selectedDates.startDate = res.startDate ? new Date(res.startDate) : new Date(0);
            this.selectedDates.endDate = res.endDate ? new Date(res.endDate) : new Date();
            this.filterByCommunity();
        },
        async getCommunities() {
            const {data} = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/sidebar-community`, {headers: {'x-access-token': this.token}})
            .catch(err => {
                if (err.response.status  === 401) {
                    localStorage.removeItem('authUser');
                    this.$router.push('/login');
                }
            });
            this.communities = data;
            const communityId = this.$route.params.community_id || this.$route.query.community_id || localStorage.getItem('user_modal_option');
            if(communityId && communityId !== 'all') {
                var selectedCommunity = data.filter(community => community._id == communityId);
                if (selectedCommunity.length >= 1) {
					this.selected = selectedCommunity[0]._id;
				}
			} else {
				// Only auto-select when no community was already set in created().
				const isValid = this.communities.some(c => c._id === this.selected);
				if (!isValid) {
					this.selected = this.communities.length <= 1 ? this.communities[0]._id : 'all';
				}
			}
			this.filterByCommunity();
			// Read circle from query params (passed from the dashboard widget) — applied
			// after filterByCommunity() since that resets selectedCircle to "all" and
			// rebuilds `circles` for the now-selected community. Mirrors requests.vue.
			const circleParam = this.$route.query.circle;
			if (circleParam && circleParam !== 'all') {
				this.selectedCircle = circleParam;
				this.filterByCircle();
			}
			this.isReady = true;
        },
        filterByCommunity: async function() {
            // console.log("filterByCommunity")
            this.selectedCircle = "all";
                if (this.selected == "all") {
                    this.circles = [];
                    this.serverURL = `${process.env.VUE_APP_API_BASE_URL}/dashboard/satisfaction?startDate=${this.getDateISO(this.selectedDates.startDate)}&&endDate=${this.getDateISO(this.selectedDates.endDate)}`;
                } else {
                    this.circles = this.communities.find(c => c._id == this.selected).additionalParams;
                    this.circles.sort(function (a, b) {
					return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
				    });
                    this.serverURL = `${process.env.VUE_APP_API_BASE_URL}/dashboard/${this.selected}/satisfactions?startDate=${this.getDateISO(this.selectedDates.startDate)}&&endDate=${this.getDateISO(this.selectedDates.endDate)}`;
                }
        },
		filterByCircle: async function () {
            // console.log("filterByCircle")
			if (this.selectedCircle == "all") {
				this.serverURL = `${process.env.VUE_APP_API_BASE_URL}/dashboard/${this.selected}/satisfactions?startDate=${this.getDateISO(this.selectedDates.startDate)}&&endDate=${this.getDateISO(this.selectedDates.endDate)}`;
			} else {
				this.serverURL = `${process.env.VUE_APP_API_BASE_URL}/dashboard/${this.selected}/satisfactions?circle=${this.selectedCircle}&&startDate=${this.getDateISO(this.selectedDates.startDate)}&&endDate=${this.getDateISO(this.selectedDates.endDate)}`;
			}
		},
    exportData: async function() {
        if (this.askCount > 0) {
            this.showDownloadingMsg();
            this.exportBtn = false;
            this.processBtn = true;
            const startDate = this.getDateISO(this.selectedDates.startDate);
            const endDate = this.getDateISO(this.selectedDates.endDate);
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/dashboard/satisfaction/export/?community=${this.selected ? this.selected : ''}&circle=${this.selectedCircle ? this.selectedCircle : ''}&query=${this.searchQuery}&&startDate=${startDate}&&endDate=${endDate}`, {headers: {'x-access-token': this.token}}).then(async response => {
                if (response.data.satisfactionData.feedback.length) {
                    await exportCSV(response.data.satisfactionData.feedback.slice(), 'feedbacks', ['requestId','memberId'], ['received']);
                    this.exportBtn = true;
                    this.processBtn = false;
                } else {
                    this.showWarnMsg();
                    this.exportBtn = true;
                    this.processBtn = false;
                }
            }).catch(err => {
                if (err.response.status  === 401) {
                    localStorage.removeItem('authUser');
                    this.$router.push('/login');
                }
            });
        } else {
            this.showWarnMsg();
        }
    },
    redirectUrls: function(path) {
      window.open((`/engagement/members/${path}`), '_blank');
    },
    openRequestInNewTab(path) {
        window.open((`/engagement/requests/${path}`), '_blank');
    },
    handleSearch(searchText) {
        // Use the search text from the child component to filter your table
        this.$refs.feedbackTable.setFilter(searchText);
    },
    handleLimitChange(newLimit) {
        // Use the new limit value from the child to update your table
        this.$refs.feedbackTable.setLimit(newLimit);
    }
  }
}
</script>
<style scoped>
/* ::v-deep reaches into v-server-table's own rendered markup — it's a separate
   component, so plain scoped CSS on this file can't touch its <tbody> otherwise.
   Each cell keeps its own real, browser-computed size and position — no absolute
   positioning or header-height guessing, so this can't misalign with the real
   header the way an overlay could. Only the cell's TEXT is hidden and swapped
   for a shimmer bar drawn in the same spot; the real <thead> is never touched. */
.table-refresh-wrapper.is-refreshing ::v-deep tbody td {
	position: relative;
	color: transparent !important;
}
.table-refresh-wrapper.is-refreshing ::v-deep tbody td * {
	visibility: hidden;
}
.table-refresh-wrapper.is-refreshing ::v-deep tbody td::before {
	content: '';
	position: absolute;
	top: 6px;
	bottom: 6px;
	left: 8px;
	right: 8px;
	border-radius: 4px;
	background: linear-gradient(90deg, rgba(255, 255, 255, 0.06) 25%, rgba(255, 255, 255, 0.14) 37%, rgba(255, 255, 255, 0.06) 63%);
	background-size: 400% 100%;
	animation: table-skeleton-pulse 1.4s ease infinite;
}
@keyframes table-skeleton-pulse {
	0% { background-position: 100% 50%; }
	100% { background-position: 0% 50%; }
}
</style>
